import { c as _c } from "react-compiler-runtime";
import { DraggableResizableHeaderContent } from './DraggableResizableHeaderContent';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentComponent = /*#__PURE__*/memo(t0 => {
  const $ = _c(14);
  const {
    column: t1,
    originalWidth,
    columnIndex,
    handleResize,
    onResizeEnd,
    onColumnOrderChange,
    arrowsNode,
    hasNewTableHeader,
    sortDirection,
    children
  } = t0;
  const {
    columnNamespace,
    columnName,
    resizable,
    reorderable
  } = t1;
  let t2;
  if ($[0] !== arrowsNode || $[1] !== children || $[2] !== columnIndex || $[3] !== columnName || $[4] !== columnNamespace || $[5] !== handleResize || $[6] !== hasNewTableHeader || $[7] !== onColumnOrderChange || $[8] !== onResizeEnd || $[9] !== originalWidth || $[10] !== reorderable || $[11] !== resizable || $[12] !== sortDirection) {
    t2 = /*#__PURE__*/_jsx(DraggableResizableHeaderContent, {
      arrowsNode: arrowsNode,
      columnNamespace: columnNamespace,
      columnName: columnName,
      columnIndex: columnIndex,
      onColumnOrderChange: onColumnOrderChange,
      handleResize: handleResize,
      onResizeEnd: onResizeEnd,
      originalWidth: originalWidth,
      reorderable: reorderable,
      resizable: resizable,
      hasNewTableHeader: hasNewTableHeader,
      sortDirection: sortDirection,
      children: children
    });
    $[0] = arrowsNode;
    $[1] = children;
    $[2] = columnIndex;
    $[3] = columnName;
    $[4] = columnNamespace;
    $[5] = handleResize;
    $[6] = hasNewTableHeader;
    $[7] = onColumnOrderChange;
    $[8] = onResizeEnd;
    $[9] = originalWidth;
    $[10] = reorderable;
    $[11] = resizable;
    $[12] = sortDirection;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
});